import { EVENT_TYPES } from "nemuru-components";
import React, { useContext, useState } from "react";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { useEventDispatcher } from "../../../../utils/hooks/useEventDispatcher";
import { MILESTONES } from "../../../shared/sharedKernel/EventCatcher/config";
import LenderSpecificOptIns from "./components/LenderSpecificOptIns";
import Signature from "./components/Signature";

export default function OptInsAndSignature() {
  const { dispatch } = useContext(ProcessContext);

  const { dispatchEvent } = useEventDispatcher();

  const [optInsState, setOptInsState] = useState({
    omitted: false,
    completed: false,
  });

  const onOptInsOmit = () => {
    setOptInsState((s) => ({ ...s, omitted: true }));
  };

  const onOptInsSuccess = () => {
    setOptInsState((s) => ({ ...s, completed: true }));
  };

  const onSignatureOmit = () => {
    if (optInsState.omitted) {
      skipModule();
    } else {
      setModuleOk();
    }
  };

  const skipModule = () => {
    dispatch({
      type: "SET_MODULE_SKIPPED",
    });
  };

  const moduleSuccess = () => {
    dispatchEvent({
      name: MILESTONES.CONTRACT_SIGNED,
      type: EVENT_TYPES.milestoneCompleted,
    });
    setModuleOk();
  };

  const setModuleOk = () => {
    dispatch({
      type: "SET_FLOW_ITEM_OK",
    });
  };

  const lenderSpecificOptInsResolved =
    optInsState.omitted || optInsState.completed;
  return (
    <>
      {!lenderSpecificOptInsResolved ? (
        <LenderSpecificOptIns
          onOmit={onOptInsOmit}
          onSuccess={onOptInsSuccess}
        />
      ) : (
        <Signature onOmit={onSignatureOmit} onSuccess={moduleSuccess} />
      )}
    </>
  );
}
